import RestaurantOfferStore from '@components/offer/stores/RestaurantOfferStore';
import { Box } from '@mui/material';
import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import React from 'react';
import FoodCategoryListItem from './FoodCategoryListItem';
import FoodCategory from '@components/offer/models/FoodCategory';

interface FoodCategoryListProps {
    restaurantOfferStore: RestaurantOfferStore;
}

const FoodCategoryList: React.FC<FoodCategoryListProps> = observer(({ restaurantOfferStore }) => {
    const { selectedRestaurant, onFoodCategoryClick } = restaurantOfferStore;

    const handleOnFoodCategoryClick = (foodCategory: FoodCategory) => {
        onFoodCategoryClick(foodCategory);
        window.scrollTo({ top: 0, behavior: "smooth" })
    }

    return (
        <Box
            display={"grid"}
            gridTemplateColumns={"repeat(2, minmax(0, 1fr))"}
            gap={2}
            p={2}
            pt={2}
            pb={3}>
            {_.map(selectedRestaurant?.foodCategories, (foodCategory) => (
                <FoodCategoryListItem
                    key={foodCategory.id}
                    foodCategory={foodCategory}
                    onClick={handleOnFoodCategoryClick} />
            ))}
        </Box>
    )
})

export default FoodCategoryList;